export function OnboardImage2() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 389 493' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3383_11432)'>
        <rect opacity='0.26' width='10' height='10' transform='matrix(1 0 0 -1 308.705 107)' fill='var(--black)' />
        <rect opacity='0.22' width='10' height='10' transform='matrix(1 0 0 -1 241.705 76)' fill='var(--black)' />
        <rect opacity='0.36' width='10' height='10' transform='matrix(1 0 0 -1 178.705 107)' fill='var(--black)' />
        <rect opacity='0.17' width='10' height='10' transform='matrix(1 0 0 -1 241.705 179)' fill='var(--black)' />
        <rect opacity='0.3' width='10' height='10' transform='matrix(1 0 0 -1 61.7048 124)' fill='var(--black)' />
        <rect opacity='0.39' width='10' height='10' transform='matrix(1 0 0 -1 147.705 53)' fill='var(--black)' />
        <rect opacity='0.23' width='10' height='10' transform='matrix(1 0 0 -1 34.7048 28)' fill='var(--black)' />
        <rect opacity='0.27' width='10' height='10' transform='matrix(1 0 0 -1 318.705 222)' fill='var(--black)' />
        <rect opacity='0.37' width='10' height='10' transform='matrix(1 0 0 -1 97.7048 455)' fill='var(--black)' />
        <rect opacity='0.38' width='10' height='10' transform='matrix(1 0 0 -1 39.7048 399)' fill='var(--black)' />
        <rect opacity='0.23' width='10' height='10' transform='matrix(1 0 0 -1 273.705 414)' fill='var(--black)' />
        <rect opacity='0.12' width='10' height='10' transform='matrix(1 0 0 -1 283.705 475)' fill='var(--black)' />
        <rect opacity='0.28' width='10' height='10' transform='matrix(1 0 0 -1 149.705 409)' fill='var(--black)' />
        <rect opacity='0.17' width='10' height='10' transform='matrix(1 0 0 -1 49.7048 201)' fill='var(--black)' />
        <path
          d='M196.029 202.052H193.593V203.713H192.651V204.543H190.935V205.429H189.44V207.09H190.16V208.751H191.046V212.96H193.426V212.074H196.084V212.96H198.52V208.751H199.462V207.09H200.237V205.429H198.52V204.543H196.859V203.713H196.029V202.052Z'
          fill='var(--yellow)'
        />
        <path
          d='M196.029 203.547H193.593V203.658H192.596V204.488H190.935V205.429H189.385V207.091H190.215V208.752H191.046V208.862H191.821V211.299H197.026L196.97 204.544L196.029 204.488V203.547Z'
          fill='var(--yellow)'
        />
        <path d='M196.084 204.543H195.254V207.09H192.707L192.762 208.696H196.084V204.543Z' fill='var(--yellow)' />
        <rect x='193.371' y='201' width='2.65773' height='0.99665' fill='var(--orange)' />
        <rect x='193.371' y='212.074' width='2.65773' height='0.99665' fill='var(--orange)' />
        <rect x='190.935' y='212.959' width='2.65773' height='0.99665' fill='var(--orange)' />
        <rect x='196.029' y='212.959' width='2.65773' height='0.99665' fill='var(--orange)' />
        <rect
          x='196.029'
          y='203.658'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 196.029 203.658)'
          fill='var(--orange)'
        />
        <rect
          x='192.596'
          y='203.658'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 192.596 203.658)'
          fill='var(--orange)'
        />
        <rect
          x='188.388'
          y='207.09'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 188.388 207.09)'
          fill='var(--orange)'
        />
        <rect
          x='189.163'
          y='208.751'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 189.163 208.751)'
          fill='var(--orange)'
        />
        <rect
          x='190.049'
          y='212.959'
          width='4.20808'
          height='0.99665'
          transform='rotate(-90 190.049 212.959)'
          fill='var(--orange)'
        />
        <rect
          x='198.576'
          y='212.959'
          width='4.20808'
          height='0.99665'
          transform='rotate(-90 198.576 212.959)'
          fill='var(--orange)'
        />
        <rect
          x='200.237'
          y='207.09'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 200.237 207.09)'
          fill='var(--orange)'
        />
        <rect
          x='199.462'
          y='208.751'
          width='1.66108'
          height='0.99665'
          transform='rotate(-90 199.462 208.751)'
          fill='var(--orange)'
        />
        <rect x='190.935' y='203.547' width='1.66108' height='0.99665' fill='var(--orange)' />
        <rect x='196.915' y='203.547' width='1.66108' height='0.99665' fill='var(--orange)' />
        <rect x='198.576' y='204.433' width='1.66108' height='0.99665' fill='var(--orange)' />
        <rect x='189.274' y='204.433' width='1.66108' height='0.99665' fill='var(--orange)' />
        <path d='M195.973 210.468V208.751V208.641H192.707V210.468H195.973Z' fill='var(--yellow)' />
        <path d='M195.254 207.09V204.599H192.707V207.09H195.254Z' fill='var(--white)' />
        <path
          d='M218.39 212.525L216.056 211.826L215.58 213.417L214.678 213.147L214.44 213.943L212.795 213.451L212.541 214.3L211.109 213.871L210.633 215.462L211.323 215.669L210.846 217.26L211.695 217.514L210.488 221.545L212.769 222.228L213.023 221.379L215.569 222.141L215.315 222.99L217.649 223.689L218.856 219.657L219.758 219.927L220.234 218.336L220.977 218.558L221.453 216.967L219.809 216.475L220.063 215.626L218.471 215.15L218.709 214.354L217.914 214.116L218.39 212.525Z'
          fill='var(--yellow)'
        />
        <path
          d='M217.961 213.957L215.627 213.258L215.596 213.364L214.641 213.079L214.403 213.874L212.811 213.398L212.541 214.3L211.056 213.855L210.58 215.447L211.376 215.685L210.899 217.276L211.695 217.514L211.663 217.62L212.406 217.843L211.707 220.177L216.693 221.669L218.577 215.182L217.691 214.859L217.961 213.957Z'
          fill='var(--yellow)'
        />
        <path
          d='M217.729 214.927L216.933 214.689L216.203 217.129L213.763 216.399L213.355 217.953L216.538 218.906L217.729 214.927Z'
          fill='var(--yellow)'
        />
        <rect
          x='216.146'
          y='210.755'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 216.146 210.755)'
          fill='var(--orange)'
        />
        <rect
          x='212.97'
          y='221.363'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 212.97 221.363)'
          fill='var(--orange)'
        />
        <rect
          x='210.382'
          y='221.514'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 210.382 221.514)'
          fill='var(--orange)'
        />
        <rect
          x='215.262'
          y='222.974'
          width='2.65773'
          height='0.99665'
          transform='rotate(16.6631 215.262 222.974)'
          fill='var(--orange)'
        />
        <rect
          x='217.93'
          y='214.063'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 217.93 214.063)'
          fill='var(--orange)'
        />
        <rect
          x='214.641'
          y='213.079'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 214.641 213.079)'
          fill='var(--orange)'
        />
        <rect
          x='209.625'
          y='215.161'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 209.625 215.161)'
          fill='var(--orange)'
        />
        <rect
          x='209.891'
          y='216.974'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 209.891 216.974)'
          fill='var(--orange)'
        />
        <rect
          x='209.534'
          y='221.26'
          width='4.20808'
          height='0.99665'
          transform='rotate(-73.3369 209.534 221.26)'
          fill='var(--orange)'
        />
        <rect
          x='217.702'
          y='223.705'
          width='4.20808'
          height='0.99665'
          transform='rotate(-73.3369 217.702 223.705)'
          fill='var(--orange)'
        />
        <rect
          x='220.977'
          y='218.558'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 220.977 218.558)'
          fill='var(--orange)'
        />
        <rect
          x='219.758'
          y='219.927'
          width='1.66108'
          height='0.99665'
          transform='rotate(-73.3369 219.758 219.927)'
          fill='var(--orange)'
        />
        <rect
          x='213.081'
          y='212.496'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 213.081 212.496)'
          fill='var(--orange)'
        />
        <rect
          x='218.81'
          y='214.211'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 218.81 214.211)'
          fill='var(--orange)'
        />
        <rect
          x='220.147'
          y='215.536'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 220.147 215.536)'
          fill='var(--orange)'
        />
        <rect
          x='211.236'
          y='212.869'
          width='1.66108'
          height='0.99665'
          transform='rotate(16.6631 211.236 212.869)'
          fill='var(--orange)'
        />
        <path
          d='M215.924 220.571L216.416 218.927L216.448 218.821L213.318 217.884L212.794 219.635L215.924 220.571Z'
          fill='var(--yellow)'
        />
        <path d='M216.203 217.13L216.917 214.743L214.477 214.012L213.763 216.399L216.203 217.13Z' fill='var(--white)' />
        <path
          d='M173.649 211.826L171.315 212.525L171.791 214.116L170.889 214.386L171.127 215.182L169.483 215.674L169.737 216.522L168.305 216.951L168.781 218.542L169.471 218.336L169.947 219.927L170.795 219.673L172.002 223.705L174.283 223.022L174.029 222.174L176.575 221.412L176.829 222.26L179.163 221.562L177.957 217.53L178.858 217.261L178.382 215.669L179.125 215.447L178.649 213.856L177.004 214.348L176.75 213.499L175.159 213.975L174.921 213.18L174.125 213.418L173.649 211.826Z'
          fill='var(--yellow)'
        />
        <path
          d='M174.077 213.258L171.743 213.957L171.775 214.063L170.82 214.348L171.059 215.144L169.467 215.62L169.737 216.522L168.252 216.967L168.728 218.558L169.524 218.32L170 219.911L170.796 219.673L170.827 219.779L171.57 219.557L172.268 221.891L177.255 220.399L175.265 213.943L174.347 214.16L174.077 213.258Z'
          fill='var(--yellow)'
        />
        <path
          d='M174.416 214.197L173.62 214.435L174.351 216.875L171.911 217.606L172.424 219.128L175.607 218.176L174.416 214.197Z'
          fill='var(--orange)'
        />
        <rect
          x='170.801'
          y='211.58'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 170.801 211.58)'
          fill='var(--orange)'
        />
        <rect
          x='173.976'
          y='222.189'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 173.976 222.189)'
          fill='var(--orange)'
        />
        <rect
          x='171.896'
          y='223.736'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 171.896 223.736)'
          fill='var(--orange)'
        />
        <rect
          x='176.776'
          y='222.276'
          width='2.65773'
          height='0.99665'
          transform='rotate(-16.66 176.776 222.276)'
          fill='var(--orange)'
        />
        <rect
          x='174.109'
          y='213.364'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 174.109 213.364)'
          fill='var(--orange)'
        />
        <rect
          x='170.82'
          y='214.349'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 170.82 214.349)'
          fill='var(--orange)'
        />
        <rect
          x='167.773'
          y='218.844'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 167.773 218.844)'
          fill='var(--orange)'
        />
        <rect
          x='168.992'
          y='220.213'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 168.992 220.213)'
          fill='var(--orange)'
        />
        <rect
          x='171.047'
          y='223.99'
          width='4.20808'
          height='0.99665'
          transform='rotate(-106.66 171.047 223.99)'
          fill='var(--orange)'
        />
        <rect
          x='179.216'
          y='221.546'
          width='4.20808'
          height='0.99665'
          transform='rotate(-106.66 179.216 221.546)'
          fill='var(--orange)'
        />
        <rect
          x='179.125'
          y='215.447'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 179.125 215.447)'
          fill='var(--orange)'
        />
        <rect
          x='178.858'
          y='217.26'
          width='1.66108'
          height='0.99665'
          transform='rotate(-106.66 178.858 217.26)'
          fill='var(--orange)'
        />
        <rect
          x='169.197'
          y='214.719'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 169.197 214.719)'
          fill='var(--orange)'
        />
        <rect
          x='174.926'
          y='213.004'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 174.926 213.004)'
          fill='var(--orange)'
        />
        <rect
          x='176.771'
          y='213.377'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 176.771 213.377)'
          fill='var(--orange)'
        />
        <rect
          x='167.86'
          y='216.044'
          width='1.66108'
          height='0.99665'
          transform='rotate(-16.66 167.86 216.044)'
          fill='var(--orange)'
        />
        <path
          d='M176.009 219.905L175.517 218.26L175.485 218.154L172.355 219.091L172.879 220.841L176.009 219.905Z'
          fill='var(--yellow)'
        />
        <path
          d='M174.351 216.876L173.636 214.489L171.196 215.219L171.911 217.606L174.351 216.876Z'
          fill='var(--white)'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 0.9646 247.777)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 0.9646 324.667)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 7.31934 253.496)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect x='41.671' y='241.422' width='70.5358' height='6.35458' fill='var(--black)' fillOpacity='0.3' />
        <rect x='41.671' y='330.386' width='70.5358' height='6.35458' fill='var(--black)' fillOpacity='0.3' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 41.671 247.777)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 118.562 247.777)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 118.562 324.667)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 42.3066 324.667)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 124.916 253.496)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 35.9514 253.496)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <path
          d='M79.4403 270.202L83.559 270.202L83.559 274.321L87.6777 274.321L87.6777 278.44L71.2029 278.44L71.2029 286.677L87.6777 286.677L87.6777 290.796L71.2029 290.796L71.2029 299.033L87.6777 299.033L87.6777 303.152L83.559 303.152L83.559 307.271L79.4403 307.271L79.4403 303.152L75.3216 303.152L75.3216 307.271L71.2029 307.271L71.2029 303.152L62.9655 303.152L62.9655 299.033L67.0842 299.033L67.0842 290.796L62.9655 290.796L62.9655 286.677L67.0842 286.677L67.0842 278.44L62.9655 278.44L62.9655 274.321L71.2029 274.321L71.2029 270.202L75.3216 270.202L75.3216 274.321L79.4403 274.321L79.4403 270.202ZM87.6777 299.033L87.6777 290.796L91.7964 290.796L91.7964 299.033L87.6777 299.033ZM87.6777 286.677L87.6777 278.44L91.7964 278.44L91.7964 286.677L87.6777 286.677Z'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <path
          d='M229.715 248.041H159.55V254.219H153.813L153.371 324.384H159.991V330.562L229.715 330.121V324.826H236.334L235.893 254.219H229.715V248.041Z'
          fill='var(--purple)'
        />
        <path
          d='M229.456 247.688V253.953H159.143L160.1 324.267H153.573V253.953H159.143V247.688H229.456Z'
          fill='#5E33DC'
        />
        <path
          d='M230.152 254.649H235.722V324.267H229.456V330.532H159.839V324.963L229.456 324.267L230.152 254.649Z'
          fill='#291170'
        />
        <rect x='159.267' y='241.422' width='70.5358' height='6.35458' fill='var(--liz)' />
        <rect x='159.267' y='330.386' width='70.5358' height='6.35458' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 159.267 247.777)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 171.341 259.215)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 224.719 259.215)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 224.719 312.593)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 171.341 312.593)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 236.158 247.777)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 236.158 324.667)' fill='var(--liz)' />
        <rect width='6.35458' height='6.35458' transform='matrix(-1 0 0 1 159.903 324.667)' fill='var(--liz)' />
        <rect width='6.35458' height='71.1713' transform='matrix(-1 0 0 1 242.512 253.496)' fill='var(--liz)' />
        <rect width='6.35458' height='71.1713' transform='matrix(-1 0 0 1 153.548 253.496)' fill='var(--liz)' />
        <path
          d='M183.802 299V282.093H177.845V279.101H193.29V282.093H187.346V299H183.802ZM194.586 299L201.895 287.706L201.082 290.547V288.933L194.641 279.101H198.834L203.467 286.589H205.095L202.792 287.926L208.225 279.101H212.21L205.563 289.03V290.643L204.722 287.802L212.1 299H208.004L203.302 291.677H201.661L204.019 290.367L198.461 299H194.586Z'
          fill='white'
        />
        <rect x='276.864' y='241.422' width='70.5358' height='6.35458' fill='var(--black)' fillOpacity='0.3' />
        <rect x='276.864' y='330.386' width='70.5358' height='6.35458' fill='var(--black)' fillOpacity='0.3' />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 276.864 247.777)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 353.755 247.777)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 353.755 324.667)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 277.5 324.667)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 360.109 253.496)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 271.145 253.496)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <path
          d='M314.633 270.202L318.752 270.202L318.752 274.321L322.871 274.321L322.871 278.44L306.396 278.44L306.396 286.677L322.871 286.677L322.871 290.796L306.396 290.796L306.396 299.033L322.871 299.033L322.871 303.152L318.752 303.152L318.752 307.271L314.633 307.271L314.633 303.152L310.515 303.152L310.515 307.271L306.396 307.271L306.396 303.152L298.159 303.152L298.159 299.033L302.277 299.033L302.277 290.796L298.159 290.796L298.159 286.677L302.277 286.677L302.277 278.44L298.159 278.44L298.159 274.321L306.396 274.321L306.396 270.202L310.515 270.202L310.515 274.321L314.633 274.321L314.633 270.202ZM322.871 299.033L322.871 290.796L326.99 290.796L326.99 299.033L322.871 299.033ZM322.871 286.677L322.871 278.44L326.99 278.44L326.99 286.677L322.871 286.677Z'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 394.461 247.777)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='6.35458'
          transform='matrix(-1 0 0 1 395.097 324.667)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
        <rect
          width='6.35458'
          height='71.1713'
          transform='matrix(-1 0 0 1 388.741 253.496)'
          fill='var(--black)'
          fillOpacity='0.3'
        />
      </g>
      <defs>
        <clipPath id='clip0_3383_11432'>
          <rect width='389' height='493' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
